import { FC, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import { useCookies } from 'react-cookie'
import useAuth from '../../hooks/useAuth'
import useMessage from '../../hooks/useMessage'
import useLoader from '../../hooks/useLoader'
import { createTokenSocialCall, getTokenSocialCall } from '../../api/token'
import { loginUser } from '../../helperFunctions/loginUser'

// Call Back Social Login
const LoginCallBackPage: FC = () => {
    // Global
    const navigate = useNavigate()
    const { setLoader } = useLoader()
    const { setType, setMessage, setShow } = useMessage()
    const { auth, setAuth } = useAuth()
    const { social = '' } = useParams()
    const { t }: { t: TFunction } = useTranslation('login')
    const [, setCookie] = useCookies()

    // Get Token Load
    const getTokenLoad = async () => {
        setLoader(1)

        const params = new URLSearchParams(window.location.search)
        const code = params.get('code') || ''
        const state = params.get('state') || ''
        const scope = params.get('scope') || ''

        try {
            const socialU = social.charAt(0).toUpperCase() + social.slice(1)
            const response = await getTokenSocialCall(code, state, scope, socialU, 'login')
            if (response.user_social_exist) {
                const responseToken = await createTokenSocialCall(response.access_token, socialU)
                loginUser(responseToken.token, responseToken.refresh_token, setAuth, setCookie, navigate)
            } else {
                if (response.user_exist) {
                    setMessage(t('login-callback-page.error.user-not-social.message'))
                } else {
                    setMessage(t('login-callback-page.error.user-not-found.message'))
                }
                setType('error')
                setShow(true)
                navigate('/login')
            }
        } catch (error: any) {
            if (error.response.status === 404) {
                setMessage(t('login-callback-page.error.user-not-found.message'))
            } else {
                setMessage(t('login-callback-page.error.token-problem.message'))
            }
            setType('error')
            setShow(true)
            navigate('/login')
        }
        setLoader(0)
    }

    useEffect(() => {
        // Redirect if connected
        if (auth?.username) {
            if (auth.roles.includes('ROLE_PARENT')) {
                navigate('/activity')
            } else if (auth.roles.includes('ROLE_STAFF')) {
                navigate('/staff')
            } else {
                navigate('/')
            }
        } else {
            getTokenLoad()
        }
    }, [])

    return null
}

export default LoginCallBackPage
